







import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

import MasterList from '../components/MasterList.vue'
import TabControl from '../components/TabControl.vue'
import FunctionEditor from '../components/FunctionEditor.vue'
import FunctionTest from '../components/FunctionTest.vue'

@Component({
  components: {
    MasterList,
    TabControl
  },
  computed: mapState({
    functions: (state: any) => state.functions.all,
    currentFn: (state: any) => state.functions.current
  })
})
export default class Functions extends Vue {
  tabs = [
    {
      title: 'Code',
      component: 'FunctionEditor'
    },
    {
      title: 'Test',
      component: 'FunctionTest'
    }
  ]

  created () {
    Vue.component('FunctionEditor', FunctionEditor)
    Vue.component('FunctionTest', FunctionTest)

    this.$store.dispatch('functions/selectFunction', this.$route.params.name)
  }

  updated () {
    this.$store.dispatch('functions/selectFunction', this.$route.params.name)
  }
}
